import http from 'services/http-service';

const AuthorService = {
    Create(name: string, shortBio: string, about: string, posterImage: any) {
        let formData = new FormData();
        formData.append("name", name);
        formData.append("shortBioData", shortBio);
        formData.append("about", about);
        formData.append("posterImage", posterImage);

        var result = http.post("/authors", formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            }
        });
        return result;
    },

    Update(authorId: any, name: string, shortBioData: string, about: string, status: number) {
        var response = http.put(`/authors/${authorId}`, { name, shortBioData, about, status });
        return response;
    },

    ChangeImage(authorId: any, posterImage: any) {
        let formData = new FormData();
        formData.append("posterImage", posterImage);

        var result = http.put(`/authors/${authorId}/image`, formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            }
        });
        return result;
    },

    Delete(authorId: any) {
        var response = http.delete(`/authors/${authorId}`);
        return response;
    },

    GetAll() {
        let response = http.get('/authors/all');
        return response;
    },

    Get(authorId: any) {
        let response = http.get(`/authors/${authorId}`);
        return response;
    }
};

export default AuthorService;